export default "__VITE_ASSET__CLesoOD1__"